import type { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";
import React, { createElement } from "react";

export interface CKButtonProps<T extends PropsWithChildren>
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  Link?: FC<T>;
  Loading?: FC;
  disabled?: boolean;
  loading?: boolean;
  link?: T;
  as?: keyof JSX.IntrinsicElements | FC<any>;
}
export const CKButton = <T extends PropsWithChildren>({
  Link,
  Loading,
  disabled,
  loading,
  link,
  as = "button",
  children,
  ...props
}: PropsWithChildren<CKButtonProps<T>>) => {
  const buttonChildren = (
    <>
      {children}
      {loading && Loading ? <Loading /> : null}
    </>
  );
  return link && Link
    ? createElement(Link, link, <span {...props}>{buttonChildren}</span>)
    : createElement(
        as,
        {
          ...props,
          disabled: disabled || loading,
        },
        buttonChildren
      );
};
